import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Device} from '../../../shared/classes/device/device';
import {faEdit, faEye, faPlus, faTrashAlt} from '@fortawesome/free-solid-svg-icons';
import {ToastrService} from 'ngx-toastr';
import {StatesService} from '../../../shared/services/state/states.service';
import {DeviceService} from '../../../shared/services/device/device.service';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {DeviceParamLirisV2} from '../../../shared/classes/device/type-v2/device-param-liris-v2';
import {DeviceParamOptV5} from '../../../shared/classes/device/type-v5/device-param-opt-v5';
import {DeviceParamExtV5} from '../../../shared/classes/device/type-v5/device-param-ext-v5';
import {DeviceParamInclinoV2} from '../../../shared/classes/device/type-v2/device-param-inclino-v2';
import {ReferentialService} from '../../../shared/services/referential/referential.service';
import {AuthenticationService} from '../../../shared/services/authentication/authentication.service';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs/index';
import {DeviceParamLirisV3} from '../../../shared/classes/device/type-v3/device-param-liris-v3';
import {DeviceParamGatewayV3} from '../../../shared/classes/device/type-gateway-v3/device-param-gateway-v3';
import {DeviceParamDauV5} from '../../../shared/classes/device/type-v5/device-param-dau-v5';
import {VSensorService} from './forms-params/v-sensor/v-sensor-shared/v-sensor.service';
import {ModalService} from '../../../shared/services/modal/modal.service';
import {DeviceParamWavesoft} from '../../../shared/classes/device/type-wavesoft/device-param-wavesoft';
import {DeviceTypes} from '../../../shared/enum/devicetypes.enum';

@Component({
  selector: 'app-device-crud',
  templateUrl: './device-crud.component.html',
  styleUrls: ['./device-crud.component.css']
})
export class DeviceCrudComponent implements OnInit {
  public DeviceTypes = DeviceTypes;
  public faPlus = faPlus;
  public faEye = faEye;
  public faEdit = faEdit;
  public faTrashAlt = faTrashAlt;
  public showSpinner: boolean;
  public showSpinnerDelete: boolean;
  @Input('displayLink') displayLink: string = null;
  @Input('deviceId') deviceId = null;
  @Input('mode') mode = null;
  @Input('deviceType') deviceTypes = [];
  @Input('unitList') unitList = [];
  @Input('children_device') children_device = null;
  public deviceTypeSelected: number = 0;
  public device: Device = new Device();
  public readOnly: boolean = true;

  public deviceForm: FormGroup;
  public paramFormLirisV2: FormGroup;
  public paramFormInclinoV2: FormGroup;
  public paramFormOptV5: FormGroup;
  public paramFormExtV5: FormGroup;
  public paramFormDauV5: FormGroup;
  public paramFormWaveSoftDevices: FormGroup;
  public paramFormLiris420: FormGroup;

  public lengthForLiris: any[] = [];
  public lengthForOptV5: any[] = [];
  public typesOptV5: any[] = [];
  public v3Types: number[] = [
    DeviceTypes.LirisV3,
    DeviceTypes.InclinoV3,
    DeviceTypes.GatewayV3,
    DeviceTypes.ExtV3,
    DeviceTypes.Exteg,
    DeviceTypes.Liris420V3,
    DeviceTypes.Expe
  ];
  public reloadDeviceCrud: Subscription;
  public project_device_location;

  @Output() deviceLoading: EventEmitter<boolean> = new EventEmitter();


  constructor(private modalService: ModalService,
              private referentialService: ReferentialService,
              private deviceService: DeviceService,
              private toastr: ToastrService,
              public statesService: StatesService,
              public authenticationService: AuthenticationService,
              private translate: TranslateService,
              private vSensorService: VSensorService) {
    this.lengthForLiris = this.referentialService.getLengthForLiris();
    this.lengthForOptV5 = this.referentialService.getLengthForOptV5();
    this.typesOptV5 = this.referentialService.getTypeOptV5();
  }

  ngOnInit() {
    this.readOnly = (this.mode === 'read') ? true : false;
  }

  openModal(content) {
    this.initAllForms();
    if (this.mode !== 'create') {
      if (this.deviceId !== null) {
        this.deviceLoading.emit(true);
        this.deviceService.getDevice(this.deviceId).subscribe((data: any) => {
          this.setDevice(data);
          // V-Sensor
          // V-sensor params are inited only if the sensor has been (1) created and (2) affected to a location
          if (this.deviceTypeSelected === DeviceTypes.VSensor && data.project_device_location) {
            this.deviceForm.setControl('params', this.vSensorService.VSensorParamFormFactory(data.params));
            this.project_device_location = data.project_device_location;
          }
          this.modalService.openNgbModal(content, {size: 'lg'});
          this.deviceLoading.emit(false);
        }, () => this.deviceLoading.emit(false));
      }
    } else {
      this.deviceId = null;
      this.deviceTypeSelected = 0;
      this.modalService.openNgbModal(content, {size: 'lg'});
    }
    this.reloadDeviceCrud = this.statesService.reloadDeviceCrud
      .subscribe(() => this.getDevice()
      );

  }


  closeModal() {
    this.reloadDeviceCrud.unsubscribe();
    this.modalService.dismissAllNgbModals();
    this.deviceTypeSelected = 0;
    this.deviceForm.reset();
    if (this.mode === 'create') {
      this.deviceId = null;
    }
    this.device = new Device();
    this.resetAllForms();

  }

  public childrenDeviceHasDeviceType() {

    return (this.children_device && this.children_device.device_type);
  }

  public needChildOrParent() {
    return [11, 12, 18].includes(this.deviceTypeSelected) && this.deviceId !== null;
  }

  public get uid() {
    return this.deviceForm.get('uid');
  }

  public get uid_erp() {
    return this.deviceForm.get('uid_erp');
  }


  public getErrorMessageUid(): string {
    return this.uid.errors.required ?
      this.translate.instant('VALUE_FORM_REQUIRED')
      : this.uid.errors.minlength || this.uid.errors.maxlength ? this.translate.instant('UID_FORM_VALID') : '';
  }

  public getErrorMessageUidErp(): string {
    return this.uid_erp.errors.maxlength ? this.translate.instant('UID_ERP_FORM_VALID') : '';
  }

  public get device_type() {
    return this.deviceForm.get('device_type');
  }

  public getErrorMessageDeviceType(): string {
    return this.device_type.errors.min ? this.translate.instant('DEVICE_TYPE_FORM_REQUIRED') : '';
  }

  public filterListByDeviceType(type: number) {
    if (this.deviceTypeSelected !== type) {
      this.deviceTypeSelected = type;
    } else {
      this.deviceTypeSelected = 0;
    }

    if (this.mode === 'create') {
      this.resetAllForms(true);
    }

    this.deviceForm.patchValue({
      device_type: this.deviceTypeSelected
    });
    switch (this.deviceTypeSelected) {
      case DeviceTypes.LirisV2:
        this.device.params = new DeviceParamLirisV2();
        break;
      case DeviceTypes.InclinoV2:
      case DeviceTypes.InclinobiaxisV2:
        this.device.params = new DeviceParamInclinoV2();
        break;
      case DeviceTypes.OpticV5:
        this.device.params = new DeviceParamOptV5();
        break;
      case DeviceTypes.ExtV5:
        this.device.params = new DeviceParamExtV5();
        break;
      case DeviceTypes.LirisV3:
      case DeviceTypes.Exteg:
      case DeviceTypes.Liris420V3:
      case DeviceTypes.InclinoV3:
      case DeviceTypes.Expe:
      case DeviceTypes.ExtV3:
        this.device.params = new DeviceParamLirisV3();
        break;
      case DeviceTypes.GatewayV3:
        this.device.params = new DeviceParamGatewayV3();
        break;
      case DeviceTypes.DauV5:
        this.device.params = new DeviceParamDauV5();
        break;
      default:
        this.device.params = null;
    }
    if (this.deviceTypeSelected >= 1000) {
      this.device.params = new DeviceParamWavesoft();
    }

  }

  public getBadegColor(id: number) {
    let color: string = 'accent';
    if (id === 3) {
      color = 'primary';
    }
    if (id === 4) {
      color = 'warn';
    }
    return color;
  }

  public getDeviceTypeSelected() {
    let value: string = '';
    this.deviceTypes.map((dT) => {
      if (dT.value === this.deviceTypeSelected) {
        value = this.translate.instant(dT.name);
      }
    });
    return value;
  }

  public deleteDevice() {
    this.showSpinnerDelete = true;
    this.deviceService.deleteDevice(this.deviceId).subscribe(() => {
      this.statesService.reloadListDevices.next();
      this.toastr.warning(this.translate.instant('DEVICE_DELETED'), this.translate.instant('SUCCESS'));
      this.showSpinnerDelete = false;
    });
  }

  public persistDevice() {
    if (this.deviceForm.valid) {
      if (this.deviceHasChanged()) {
        this.showSpinner = true;

        this.setDeviceWithForms();


        if (this.deviceId !== null) {
          if (this.deviceTypeSelected === DeviceTypes.Liris420V3) {
            delete this.device.params.coefs;
          }
          this.deviceService.patchDevice(this.deviceId, this.device)
            .subscribe((data: any) => {
              this.setDevice(data);
              this.statesService.reloadListDevices.next();
              this.statesService.reloadProjectDevice.next();
              this.statesService.reloadProjectLocation.next();
              this.toastr.success(this.translate.instant('DEVICE_MODIFIED'), this.translate.instant('SUCCESS'));
              this.closeModal();
            }, () => this.showSpinner = false);


        } else if (this.deviceId === null) {

          this.device.level = this.statesService.stateLevel;
          this.device.parent = null;

          this.deviceService.postDevice(this.device)
            .subscribe((data: any) => {
              this.deviceId = data.id;
              this.setDevice(data);
              this.statesService.reloadListDevices.next();
              this.statesService.reloadProjectDevice.next();
              this.toastr.success(this.translate.instant('DEVICE_CREATED'), this.translate.instant('SUCCESS'));
              this.closeModal();
            }, () => this.showSpinner = false);
        }
      } else {
        this.toastr.error(this.translate.instant('SAVING_DISABLED_MESSAGE'), this.translate.instant('ERROR'));
      }
    }
  }

  public errorMessageIfInvalidForm(form: AbstractControl | FormControl | FormGroup) {
    if (form.invalid) {
      this.toastr.error(this.translate.instant('INVALID_VALUES'));
    }
  }

  firstStepCheckIfCompleted() {
    const standardCheck = this.deviceForm.get('uid').valid && this.deviceForm.get('device_type').valid;
    if (this.deviceTypeSelected === DeviceTypes.ExtV5 || this.deviceTypeSelected === DeviceTypes.VSensor) {
      return standardCheck && this.deviceForm.get('unit').value;
    } else {
      return standardCheck;
    }
  }

  private deviceHasChanged(): boolean {
    let changes = 0;

    changes = this.device.uid !== this.deviceForm.value.uid ? changes + 1 : changes;
    changes = this.device.uid_erp !== this.deviceForm.value.uid_erp ? changes + 1 : changes;
    changes = this.device.device_type !== this.deviceForm.value.device_type ? changes + 1 : changes;
    changes = this.device.active !== this.deviceForm.value.active ? changes + 1 : changes;
    changes = this.device.length !== this.deviceForm.value.length ? changes + 1 : changes;
    changes = this.device.unit !== this.deviceForm.value.unit ? changes + 1 : changes;


    if (this.deviceTypeSelected === DeviceTypes.LirisV2) {
      changes = this.device.params.paramA !== this.paramFormLirisV2.value.paramA ? changes + 1 : changes;
      changes = this.device.params.paramB !== this.paramFormLirisV2.value.paramB ? changes + 1 : changes;
      changes = this.device.params.paramC !== this.paramFormLirisV2.value.paramC ? changes + 1 : changes;
      changes = this.device.params.trigger !== this.paramFormLirisV2.value.trigger ? changes + 1 : changes;
    }

    if (this.deviceTypeSelected === DeviceTypes.InclinoV2 || this.deviceTypeSelected === DeviceTypes.InclinobiaxisV2) {
      changes = this.device.params.trigger !== this.paramFormInclinoV2.value.trigger ? changes + 1 : changes;
    }

    if (this.deviceTypeSelected === DeviceTypes.OpticV5) {
      changes = this.device.params.paramA !== this.paramFormOptV5.value.paramA ? changes + 1 : changes;
      changes = this.device.params.paramB !== this.paramFormOptV5.value.paramB ? changes + 1 : changes;
      changes = this.device.params.paramC !== this.paramFormOptV5.value.paramC ? changes + 1 : changes;
      changes = this.device.params.wp !== this.paramFormOptV5.value.wp ? changes + 1 : changes;
      changes = this.device.params.type !== this.paramFormOptV5.value.type ? changes + 1 : changes;
    }

    if (this.deviceTypeSelected === DeviceTypes.ExtV5) {
      changes = this.device.params.paramA !== this.paramFormExtV5.value.paramA ? changes + 1 : changes;
      changes = this.device.params.paramB !== this.paramFormExtV5.value.paramB ? changes + 1 : changes;
      changes = this.device.params.paramC !== this.paramFormExtV5.value.paramC ? changes + 1 : changes;
      changes = this.device.params.paramD !== this.paramFormExtV5.value.paramD ? changes + 1 : changes;
      changes = this.device.params.paramE !== this.paramFormExtV5.value.paramE ? changes + 1 : changes;
    }

    if (this.deviceTypeSelected === DeviceTypes.DauV5) {
      changes = this.device.params.screwTerminalBlock !== this.paramFormDauV5.value.screwTerminalBlock ? changes + 1 : changes;
    }

    if (this.v3Types.includes(this.deviceTypeSelected)) {
      changes = JSON.stringify(this.device.params) !== JSON.stringify(this.paramFormExtV5.value.params) ? changes + 1 : changes;

    }

    // no params on v-sensor if it has not been affected to a location
    if (this.deviceTypeSelected === DeviceTypes.VSensor && this.project_device_location) {
      changes = JSON.stringify(this.device.params) !== JSON.stringify(this.deviceForm.value.params) ? changes + 1 : changes;
    }

    if (this.deviceTypeSelected >= 1000) {
      changes = this.device.params.sold != this.paramFormWaveSoftDevices.value.sold ? changes + 1 : changes;
    }

    return changes > 0;
  }

  private getDevice() {

    if (this.deviceId !== null) {
      this.showSpinner = true;
      this.deviceService.getDevice(this.deviceId).subscribe((data: any) => {
        this.setDevice(data);
      });
    }
  }


  private setDevice(data: any) {
    this.device.setDevice(data);
    this.deviceTypeSelected = this.device.device_type;
    this.setFormsWithDevice();
    this.showSpinner = false;

  }

  private setFormsWithDevice() {

    this.deviceForm.patchValue({
      uid: this.device.uid,
      uid_erp: this.device.uid_erp,
      device_type: this.device.device_type,
      active: this.device.active,
      length: this.device.length,
      unit: this.device.unit,
    });

    if (this.deviceTypeSelected === DeviceTypes.LirisV2) {
      this.paramFormLirisV2.patchValue({
        paramA: this.device.params.paramA,
        paramB: this.device.params.paramB,
        paramC: this.device.params.paramC,
        trigger: this.device.params.trigger,
      });
    }
    if (this.deviceTypeSelected === DeviceTypes.InclinoV2 || this.deviceTypeSelected === DeviceTypes.InclinobiaxisV2) {
      this.paramFormInclinoV2.patchValue({
        trigger: this.device.params.trigger,
      });
    }
    if (this.deviceTypeSelected === DeviceTypes.OpticV5) {
      this.paramFormOptV5.patchValue({
        paramA: this.device.params.paramA,
        paramB: this.device.params.paramB,
        paramC: this.device.params.paramC,
        wp: this.device.params.wp,
        type: this.device.params.type,
      });
    }
    if (this.deviceTypeSelected === DeviceTypes.ExtV5) {
      this.paramFormExtV5.patchValue({
        paramA: this.device.params.paramA,
        paramB: this.device.params.paramB,
        paramC: this.device.params.paramC,
        paramD: this.device.params.paramD,
        paramE: this.device.params.paramE,
      });
    }
    if (this.deviceTypeSelected === DeviceTypes.DauV5) {
      this.paramFormDauV5.patchValue({
        screwTerminalBlock: this.device.params.screwTerminalBlock
      });
    }

    if (this.v3Types.includes(this.deviceTypeSelected)) {
      this.deviceForm.patchValue({
          params: this.device.params
        }
      );

    }

    if (this.deviceTypeSelected >= 1000) {
      this.paramFormWaveSoftDevices.patchValue({
        sold: this.device.params.sold
      });
    }


  }

  private setDeviceWithForms() {

    this.device.uid = this.deviceForm.value.uid;
    this.device.uid_erp = this.deviceForm.value.uid_erp;
    this.device.device_type = this.deviceForm.value.device_type;
    this.device.active = this.deviceForm.value.active;

    if (!this.v3Types.includes(this.deviceTypeSelected)) {
      // we use the devices params managed dy lirisv3component
      this.device.params = null;
    }


    if (this.deviceTypeSelected === DeviceTypes.LirisV2) {
      this.device.length = this.deviceForm.value.length;
      this.device.params = new DeviceParamLirisV2();
      this.device.params.paramA = this.paramFormLirisV2.value.paramA;
      this.device.params.paramB = this.paramFormLirisV2.value.paramB;
      this.device.params.paramC = this.paramFormLirisV2.value.paramC;
      this.device.params.trigger = this.paramFormLirisV2.value.trigger;
    }

    if (this.deviceTypeSelected === DeviceTypes.InclinoV2 || this.deviceTypeSelected === DeviceTypes.InclinobiaxisV2) {
      this.device.params = new DeviceParamInclinoV2();
      this.device.params.trigger = this.paramFormInclinoV2.value.trigger;
    }

    if (this.deviceTypeSelected === DeviceTypes.OpticV5) {
      this.device.length = this.deviceForm.value.length;
      this.device.params = new DeviceParamOptV5();
      this.device.params.paramA = this.paramFormOptV5.value.paramA;
      this.device.params.paramB = this.paramFormOptV5.value.paramB;
      this.device.params.paramC = this.paramFormOptV5.value.paramC;
      this.device.params.wp = this.paramFormOptV5.value.wp;
      this.device.params.type = this.paramFormOptV5.value.type;
    }

    if (this.deviceTypeSelected === DeviceTypes.ExtV5) {
      this.device.unit = this.deviceForm.value.unit;
      this.device.params = new DeviceParamExtV5();
      this.device.params.paramA = this.paramFormExtV5.value.paramA;
      this.device.params.paramB = this.paramFormExtV5.value.paramB;
      this.device.params.paramC = this.paramFormExtV5.value.paramC;
      this.device.params.paramD = this.paramFormExtV5.value.paramD;
      this.device.params.paramE = this.paramFormExtV5.value.paramE;
    }

    if (this.deviceTypeSelected === DeviceTypes.DauV5) {
      this.device.params = new DeviceParamDauV5();
      this.device.params.screwTerminalBlock = this.paramFormDauV5.value.screwTerminalBlock;
    }

    if (this.deviceTypeSelected === DeviceTypes.LirisV3) {
      this.device.length = this.deviceForm.value.length;
    }

    if (this.deviceTypeSelected === DeviceTypes.VSensor) {
      this.device.unit = this.deviceForm.value.unit;
      this.device.params = this.deviceForm.get('params').value;
    }

    if (this.deviceTypeSelected === DeviceTypes.GSensor) {
      this.device.unit = this.deviceForm.value.unit;
    }

    if (this.deviceTypeSelected >= 1000) {
      this.device.params = new DeviceParamWavesoft();
      this.device.params.sold = this.paramFormWaveSoftDevices.value.sold;
    }
  }

  private initAllForms() {

    this.deviceForm = new FormGroup({
      uid: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(20)]),
      uid_erp: new FormControl('', [Validators.maxLength(20)]),
      device_type: new FormControl(0, [Validators.min(1)]),
      active: new FormControl(true, [Validators.required]),
      length: new FormControl(1),
      unit: new FormControl(1),
      params: new FormControl(null)
    });

    this.paramFormLirisV2 = new FormGroup({
      paramA: new FormControl('', [Validators.required]),
      paramB: new FormControl('', [Validators.required]),
      paramC: new FormControl('', [Validators.required]),
      trigger: new FormControl('', [Validators.required]),
    });

    this.paramFormInclinoV2 = new FormGroup({
      trigger: new FormControl('', [Validators.required]),
    });

    this.paramFormOptV5 = new FormGroup({
      paramA: new FormControl('', [Validators.required]),
      paramB: new FormControl('', [Validators.required]),
      paramC: new FormControl('', [Validators.required]),
      wp: new FormControl('', [Validators.required]),
      type: new FormControl('', [Validators.required]),
    });

    this.paramFormExtV5 = new FormGroup({
      paramA: new FormControl('', [Validators.required]),
      paramB: new FormControl('', [Validators.required]),
      paramC: new FormControl('', [Validators.required]),
      paramD: new FormControl('', [Validators.required]),
      paramE: new FormControl('', [Validators.required]),
    });

    this.paramFormDauV5 = new FormGroup({
      screwTerminalBlock: new FormControl('')
    });

    this.paramFormWaveSoftDevices = new FormGroup({
      sold: new FormControl(0, [Validators.required])
    });
    this.paramFormLiris420 = new FormGroup({});
  }

  private resetAllForms(onlyParams: boolean = false) {
    if (onlyParams === false) {
      this.deviceForm.reset();
    }
    this.paramFormLirisV2.reset();
    this.paramFormInclinoV2.reset();
    this.paramFormExtV5.reset();
    this.paramFormOptV5.reset();
    this.paramFormDauV5.reset();
    this.paramFormWaveSoftDevices.reset();
  }

}
